export default __webpack_public_path__ + "static/media/icon_clock.4ad2e055.png";